import type {
    TitlesSelectionProps,
} from "../../contacts-search-profiles/components/TitlesSelection/TitlesSelection";
import TitlesSelection from "../../contacts-search-profiles/components/TitlesSelection/TitlesSelection";

type IncludedTitlesProps = Pick<TitlesSelectionProps, "selectedItems" | "id"> & {
    onChange(titles: string[]): void;
};

const IncludedTitles = ({ onChange, ...rest }: IncludedTitlesProps) => {
    function handleAdd(title: string) {
        onChange(rest.selectedItems.concat(title));
    }

    function handleRemove(title: string) {
        onChange(rest.selectedItems.filter((t) => t !== title));
    }

    return (
        <TitlesSelection
            {...rest}
            onAdd={handleAdd}
            onRemove={handleRemove}
            label={{ key: "si.account-overview.employee-profiles.include-titles.text" }}
        />
    );
}

export default IncludedTitles;
